import React from "react";
import ReactDOM from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";

// Importar providers
import { ThemeProvider } from "./context/ThemeContext";
import { NotificationProvider } from "./context/NotificationContext";
import { AuthProvider } from "./context/AuthContext";
import { HierarchyProvider } from "./context/HierarchyContext";

// Componente principal
import App from "./App";

// Estilos globales
import "./index.css";

// Configurar React 18
const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <HelmetProvider>
      <ThemeProvider>
        <NotificationProvider>
          <AuthProvider>
            <HierarchyProvider>
              <App />
            </HierarchyProvider>
          </AuthProvider>
        </NotificationProvider>
      </ThemeProvider>
    </HelmetProvider>
  </React.StrictMode>
);
